<template>
  <div ref="comparison" :style="style"></div>
</template>

<script>
  import moment from 'moment';
  import * as echarts from 'echarts';
  export default {
    props: [
      'comparisonData',
      'height',
      'countryName',
      'countryInitDate',
      'siteInitDate',
      'studyInitDate',
    ],
    data() {
      return {
        data: [],
        style: '',
        myChart: {},
        date: '',
      };
    },
    created() {
      this.style = `margin:0px; width:100%;  min-height:${this.height}`;
      window.addEventListener('resize', () => {
        if (this.myChart !== null && this.myChart !== undefined) {
          this.myChart.resize();
        }
      });
    },
    destroyed() {
      this.myChart = null;
    },
    mounted() {
      this.myChart = echarts.init(this.$refs.comparison);
      let option;
      option = {
        grid: {
          left: 50,
          top: 50,
          right: 50,
          bottom: 50,
        },
        legend: {
          show: true,
          data: ['My Site', 'My Country Average', 'Study Average'],
          icon: 'roundRect',
        },
        dataset: [
          {
            id: 'dataset_raw',
            source: this.comparisonData,
          },
          {
            id: 'dataset_1',
            fromDatasetId: 'dataset_raw',
            transform: {
              type: 'filter',
              config: {
                and: [
                  { dimension: 'Date', gt: this.siteInitDate, parser: 'time' },
                  { dimension: 'Country', '=': 'MySite' },
                ],
              },
            },
          },
          {
            id: 'dataset_2',
            fromDatasetId: 'dataset_raw',
            transform: {
              type: 'filter',
              config: {
                and: [
                  { dimension: 'Date', gt: this.countryInitDate, parser: 'time' },
                  { dimension: 'Country', '=': this.countryName },
                ],
              },
            },
          },
          {
            id: 'dataset_3',
            fromDatasetId: 'dataset_raw',
            transform: {
              type: 'filter',
              config: {
                and: [
                  { dimension: 'Date', gt: this.studyInitDate, parser: 'time' },
                  { dimension: 'Country', '=': 'MyStudy' },
                ],
              },
            },
          },
        ],
        tooltip: {
          trigger: 'axis',
          formatter: params => {
            this.date = moment(params[0]['data'][2]).format('D MMM YYYY');
            if (params.length === 3) {
              return `${this.date}</br>
                <strong> My Site </strong>: ${params[0]['data'][0]} <br />
                <strong> My Country Average </strong>: ${params[1]['data'][0]} <br />
                <strong> Study Average </strong>: ${params[2]['data'][0]} <br /> `;
            } else if (params.length === 2) {
              return this.paramsSizeTwo(params[0], params[1]);
            } else if (params.length === 1) {
              return this.paramsSizeOne(params[0]);
            }
          },
        },
        xAxis: {
          type: 'time',
          splitNumber: 8,
          axisLabel: {
            hideOverlap: true,
          },
          min: 'dataMin',
          max: 'dataMax',
          splitLine: { show: false },
          axisLine: {
            show: true,
          },
          axisTick: {
            show: true,
            alignWithLabel: true,
            length: 4,
          },
        },
        yAxis: {
          splitNumber: 4,
          min: 0,
          max: 'dataMax',
          splitLine: { show: false },
          axisLine: {
            show: true,
          },
          axisTick: {
            show: true,
            alignWithLabel: true,
            length: 4,
          },
        },
        series: [
          {
            type: 'line',
            datasetId: 'dataset_1',
            name: 'My Site',
            showSymbol: false,
            color: '#FFC043',
            smooth: true,
            encode: {
              x: 'Date',
              y: 'Enrollments',
              itemName: 'Date',
              tooltip: ['Enrollments'],
            },
          },
          {
            type: 'line',
            datasetId: 'dataset_2',
            name: 'My Country Average',
            showSymbol: false,
            color: '#18A0FB',
            smooth: true,
            encode: {
              x: 'Date',
              y: 'Enrollments',
              itemName: 'Date',
              tooltip: ['Enrollments'],
            },
          },
          {
            type: 'line',
            datasetId: 'dataset_3',
            name: 'Study Average',
            showSymbol: false,
            color: '#05A357',
            smooth: true,
            encode: {
              x: 'Date',
              y: 'Enrollments',
              itemName: 'Date',
              tooltip: ['Enrollments'],
            },
          },
        ],
      };
      option && this.myChart.setOption(option);
    },
    methods: {
      paramsSizeTwo(data1, data2) {
        if (data1['seriesName'] === 'My Site' && data2['seriesName'] === 'Study Average') {
          return `${this.date}</br>
                <strong> My Site </strong>: ${data1['data'][0]} <br />
                <strong> Study Average </strong>: ${data2['data'][0]} <br /> `;
        } else if (
          data1['seriesName'] === 'My Site' &&
          data2['seriesName'] === 'My Country Average'
        ) {
          return `${this.date}</br>
                <strong> My Site </strong>: ${data1['data'][0]} <br />
                <strong> My Country Average </strong>: ${data2['data'][0]} <br /> `;
        } else if (
          data1['seriesName'] === 'My Country Average' &&
          data2['seriesName'] === 'Study Average'
        ) {
          return `${this.date}</br>
                <strong> My Country Average </strong>: ${data1['data'][0]} <br />
                <strong> Study Average </strong>: ${data2['data'][0]} <br /> `;
        }
      },
      paramsSizeOne(data) {
        if (data['seriesName'] === 'My Site') {
          return `${this.date}</br>
                <strong> My Site </strong>: ${data['data'][0]} <br />`;
        } else if (data['seriesName'] === 'My Country Average') {
          return `${this.date}</br>
                <strong> My Country Average </strong>: ${data['data'][0]} <br /> `;
        } else if (data['seriesName'] === 'Study Average') {
          return `${this.date}</br>
                <strong> Study Average </strong>: ${data['data'][0]} <br /> `;
        }
      },
    },
  };
</script>

<style></style>
